import { parseISO, format } from "date-fns"
import React, { useState } from "react"
import { put } from "@util/api"
import webify from "../util/webify"
import SwitchInput from "./SwitchInput"

interface AutopaySwitchProps {
  id: number
  checked: boolean
  date: string | undefined
}

const setAutoPayEnabled = (id, value) => {
  const url = `/api/autopay/${id}`
  return put(url, {
    passenger_party: { autopay_enabled: value },
  })
}

const AutopaySwitch = (props: AutopaySwitchProps) => {
  const { id, date } = props
  const [checked, setChecked] = useState(props.checked)
  let formattedDate = date && format(parseISO(date), "EE, LLL d")

  return (
    <div className="flex flex-col gap-2 bg-gray-50 border-gray-200 p-4 pt-3">
      <div className="flex items-center" data-role="autopay-switch">
        <h2 className="pl-1 mr-auto">{checked ? "AutoPay Is Enabled" : "AutoPay Is Disabled"}</h2>

        <div>
          <SwitchInput
            checked={checked}
            name=""
            labelOn=""
            labelOff=""
            labelClass=""
            permissionToEdit=""
            data-role="autopay-switch-input"
            onChange={() => {
              const newValue = !checked
              setChecked(newValue)
              setAutoPayEnabled(id, newValue)
            }}
          />
        </div>
      </div>
      <div className="max-w-para mt-2">
        {formattedDate ? (
          <>
            {checked ? (
              <p>
                Your next payment will automatically process on <strong>{formattedDate}</strong> using your default payment
                method. You'll get a heads up three days before.
              </p>
            ) : (
              <p>
                If enabled, your next payment will automatically process on {formattedDate} using your default payment
                method.
              </p>
            )}
          </>
        ) : (
          <p>AutoPay will not process any future payments because the last payment date has passed.</p>
        )}
      </div>
    </div>
  )
}

export default AutopaySwitch
webify("autopay-switch", AutopaySwitch)
